// Formulário de perfil de marca — inspirado no formulário de posicionamento
// do Asana da Vuli, reorganizado em seções. Cada campo vira uma chave dentro
// de persona_projeto.respostas (jsonb, sem precisar de migration pra mudar).
export const SECOES_PERFIL_MARCA = [
  {
    titulo: 'Sobre você',
    campos: [
      { key: 'nome_completo', tipo: 'texto', label: 'Nome completo' },
      { key: 'profissao', tipo: 'texto', label: 'Profissão' },
      { key: 'especialidades', tipo: 'texto', label: 'Especialidades ou áreas de maior interesse' },
      { key: 'tempo_atuacao', tipo: 'texto', label: 'Tempo de atuação' },
      { key: 'cidade_estado', tipo: 'texto', label: 'Cidade/Estado' },
      { key: 'atendimento', tipo: 'chips', label: 'Atende presencial, online ou ambos?', opcoes: ['Presencial', 'Online', 'Ambos'] },
    ],
  },
  {
    titulo: 'Presença digital hoje',
    campos: [
      { key: 'ja_produz_conteudo', tipo: 'chips', label: 'Hoje você já produz conteúdo?', opcoes: ['Sim', 'Não'] },
      { key: 'redes_atuais', tipo: 'chips-multi', label: 'Se sim, em quais redes?', opcoes: ['Instagram', 'TikTok', 'YouTube', 'LinkedIn', 'Facebook'] },
      { key: 'por_que_redes_sociais', tipo: 'textarea', label: 'Por que você quer estar nas redes sociais?' },
      { key: 'o_que_espera_trazer', tipo: 'chips-multi', label: 'O que você quer que as redes sociais tragam para você?', opcoes: ['Autoridade', 'Reconhecimento profissional', 'Leads qualificados', 'Vendas diretas', 'Networking'] },
      { key: 'tentativas_anteriores', tipo: 'textarea', label: 'Já tentou usar redes sociais antes? O que deu certo? O que não deu?' },
      { key: 'frequencia_gravacao', tipo: 'texto', label: 'Quantas vezes por semana você consegue gravar conteúdo?' },
      { key: 'agenda_cheia', tipo: 'chips', label: 'Você tem agenda cheia hoje?', opcoes: ['Sim', 'Não'] },
      { key: 'como_chegam_clientes', tipo: 'texto', label: 'Como chegam seus clientes/pacientes hoje?' },
    ],
  },
  {
    titulo: 'Visão e posicionamento',
    campos: [
      { key: 'visao_6_meses', tipo: 'textarea', label: 'Se tudo desse certo, como estaria sua agenda daqui a 6 meses?' },
      { key: 'como_quer_ser_conhecido', tipo: 'textarea', label: 'Como você quer ser conhecido(a) na internet?' },
      { key: 'completar_frase', tipo: 'textarea', label: '"Eu quero ser vista(o) como o(a) profissional que ___"' },
      { key: 'nao_quer_associacao', tipo: 'textarea', label: 'O que você NÃO quer que associem ao seu nome?' },
      { key: 'tres_palavras', tipo: 'texto', label: 'Cite 3 palavras que definem você' },
      { key: 'diferencial', tipo: 'textarea', label: 'O que você faz diferente da maioria dos profissionais da sua área?' },
      { key: 'por_que_escolher_voce', tipo: 'textarea', label: 'Por que um cliente/paciente deveria escolher você?' },
    ],
  },
  {
    titulo: 'Estilo de comunicação',
    campos: [
      { key: 'tom_de_voz', tipo: 'chips', label: 'Tom de voz preferido', opcoes: ['Formal e técnico', 'Próximo e acolhedor', 'Direto e assertivo', 'Descontraído e bem-humorado'] },
      { key: 'posicionamento', tipo: 'chips', label: 'Você prefere um posicionamento mais...', opcoes: ['Didático e acessível', 'Divertido e descontraído', 'Sério e técnico', 'Provocador'] },
      { key: 'humor', tipo: 'chips', label: 'Você se sente confortável com humor?', opcoes: ['Sim, bastante', 'Só em doses pequenas', 'Prefiro manter sério'] },
      { key: 'papel_no_conteudo', tipo: 'chips', label: 'Prefere aparecer mais como...', opcoes: ['Autoridade que ensina', 'Próximo (amigo/conselheiro)', 'Storyteller (casos reais)', 'Provocador'] },
      { key: 'conforto_camera', tipo: 'chips', label: 'Como você se sente na câmera?', opcoes: ['Super à vontade', 'Confortável, mas vou com calma', 'Prefiro falar pouco, direto ao ponto', 'Prefiro não aparecer (voz em off)'] },
      { key: 'confortavel_em', tipo: 'chips-multi', label: 'Você se sente confortável em...', opcoes: ['Gravar rotina', 'Aparecer em vídeo', 'Dar opinião', 'Contar histórias pessoais'] },
      { key: 'mostrar_rotina', tipo: 'chips', label: 'Estaria aberto(a) a mostrar sua rotina pessoal?', opcoes: ['Sim', 'Não', 'Só em partes'] },
      { key: 'referencias_comunicacao', tipo: 'texto', label: 'Tem alguma referência de comunicação que você gosta?' },
      { key: 'profissionais_admira', tipo: 'texto', label: 'Quais profissionais você admira no digital? (de qualquer área)' },
    ],
  },
  {
    titulo: 'Temas de conteúdo',
    campos: [
      { key: 'temas_quer_falar', tipo: 'textarea', label: 'Sobre o que você MAIS gostaria de falar?' },
      { key: 'temas_nao_quer_falar', tipo: 'textarea', label: 'Sobre o que você NÃO gostaria de falar?' },
    ],
  },
  {
    titulo: 'Seu público ideal',
    campos: [
      { key: 'publico_ideal', tipo: 'textarea', label: 'Quem é o seu cliente/público ideal? (idade, gênero, profissão, estilo de vida...)' },
      { key: 'problemas_publico', tipo: 'textarea', label: 'Quais são os principais problemas que essa pessoa enfrenta?' },
      { key: 'desejo_publico', tipo: 'textarea', label: 'O que ele MAIS deseja?' },
      { key: 'impedimento_ajuda', tipo: 'textarea', label: 'O que normalmente impede ele de procurar ajuda?' },
      { key: 'tentativas_publico', tipo: 'textarea', label: 'Ele já tentou resolver esse problema antes? Como?' },
      { key: 'duvidas_comuns', tipo: 'textarea', label: 'Quais são as dúvidas mais comuns dos seus clientes/pacientes?' },
      { key: 'medos_publico', tipo: 'textarea', label: 'Quais são os maiores medos deles?' },
      { key: 'objecoes_comuns', tipo: 'textarea', label: 'Quais objeções você mais escuta?' },
      { key: 'erros_comuns', tipo: 'textarea', label: 'Quais erros você mais vê esse público cometendo?' },
      { key: 'conselho_publico', tipo: 'textarea', label: 'Se pudesse dar um conselho pro seu cliente/paciente ideal, qual seria?' },
    ],
  },
  {
    titulo: 'Prova social e resultados',
    campos: [
      { key: 'resultados_gerados', tipo: 'textarea', label: 'Quais resultados você já gerou para clientes/pacientes?' },
      { key: 'caso_marcante', tipo: 'textarea', label: 'Você tem algum caso ou história marcante?' },
    ],
  },
  {
    titulo: 'Expectativas com esse trabalho',
    campos: [
      { key: 'expectativa_trabalho', tipo: 'textarea', label: 'O que você espera desse trabalho?' },
      { key: 'resultado_excelente', tipo: 'textarea', label: 'O que seria um resultado excelente para você?' },
      { key: 'preocupacoes', tipo: 'textarea', label: 'Existe alguma preocupação ou insegurança com esse processo?' },
    ],
  },
];
